import {useCallback} from 'react';
import {useAppContext} from '@/context/app';
import useUsersApi from '@/hooks/user/useUsersApi.ts';
import useRolesApi from '@/hooks/roles/useRolesApi.ts';
import {IUser} from '@/types/user';
import {IRole} from '@/types/role';
import useNotificationsApi from '@/hooks/notifications/useNotificationsApi.ts';
import {INotification} from '@/types/notification';
// import useAuth from './useAuth';

interface IUseLoadDataHook {
    loadData: () => Promise<void>,
}

const useLoadData = (): IUseLoadDataHook => {

    const {loaded, setLoaded, auth, setAuthUser, setAuthUserRoles, setNotifications} = useAppContext()
    const {getUserByEmail} = useUsersApi()
    const {getAllRoles} = useRolesApi()
    const {getNotifications} = useNotificationsApi()

    const loadData = useCallback((): Promise<void> => {
        return new Promise((resolve, reject) => {
            if (auth?.token && !loaded
                //&& !auth.user
            ) {
                loadUser().then((user) => {
                    Promise.all([
                        loadRoles(user),
                        loadNotifications(user)
                    ]).then(([roles, notifications]) => {
                        setAuthUser(user)
                        setAuthUserRoles(<IRole[]>roles)
                        setNotifications(<INotification[]>notifications, 'set')
                        setLoaded(true)
                        resolve()

                    }).catch((err) => reject(err))
                }).catch((err) => reject(err))
            }
        })

    }, [auth, loaded])


    const loadUser = useCallback((): Promise<IUser> => {
        return new Promise((resolve, reject) => {
            if(auth?.user){
                resolve(auth.user)
            } else if (auth.token && auth.email) {
                getUserByEmail(auth.email).then((user) => {
                    resolve(user)
                }).catch((err) => reject(err))
            }
        })
    }, [auth, loaded])


    const loadRoles = useCallback((user: IUser): Promise<IRole[]> => {
        return new Promise((resolve, reject) => {
            if (auth.token && user.roles.length > 0) {
                getAllRoles({ids: user.roles.join(',')}).then((roles) => {
                    resolve(roles)
                }).catch((err) => reject(err))
            }
        })
    }, [auth])

    const loadNotifications = useCallback((user: IUser): Promise<INotification[]> => {
        return new Promise((resolve, reject) => {
            if (auth.token) {
                getNotifications({page:1, limit: 20, sort: {timestamp: 'desc'}},{user: user._id,}).then((paginated) => {
                    resolve(paginated.items)
                }).catch((err) => reject(err))
            }
        })
    }, [auth])


    return {
        loadData
    };
};

export default useLoadData;
